import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IPortCode } from '../contracts/port-code.contract';
import { PortCodeService } from '../services';

interface IInitialState {
    List: {
        [key: string]:
            | {
                  IMONumber: string;
                  PortCode: IPortCode | null | undefined;
                  IsLoading: boolean;
                  ErrorMessage: string | undefined;
              }
            | undefined;
    };
}

const initialState: IInitialState = {
    List: {}
};

const Fetch = {
    GetBySearch: createAsyncThunk('portCode/GetBySearch', async ({ imoNumber, searchString }: { imoNumber: string; searchString: string }, { rejectWithValue }) => {
        try {
            const res = await PortCodeService.getSearch(searchString);
            return { IMONumber: imoNumber, res };
        } catch (err: any) {
            return rejectWithValue({ ...err, IMONumber: imoNumber });
        }
    })
};

const PortCodeSlice = createSlice({
    name: 'portCode',
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        // GetBySearch
        builder.addCase(Fetch.GetBySearch.pending, (state, action: any) => {
            state.List[action.meta.arg.imoNumber] = { IMONumber: action.meta.arg.imoNumber, PortCode: undefined, IsLoading: true, ErrorMessage: undefined };
        });
        builder.addCase(Fetch.GetBySearch.fulfilled, (state, action: PayloadAction<{ IMONumber: string; res: IPortCode }>) => {
            state.List[action.payload.IMONumber] = { IMONumber: action.payload.IMONumber, PortCode: action.payload.res, IsLoading: false, ErrorMessage: undefined };
        });
        builder.addCase(Fetch.GetBySearch.rejected, (state, action: PayloadAction<any>) => {
            state.List[action.payload.IMONumber] = { IMONumber: action.payload.IMONumber, PortCode: undefined, IsLoading: false, ErrorMessage: action.payload };
        });
    }
});

export const PortCodeFetch = Fetch;
export const PortCodeAction = PortCodeSlice.actions;
export const PortCodeReducer = PortCodeSlice.reducer;
